import { useState } from "react";
import { NormTextList } from "./NormTextList";
import type { Grade, LearningExercise } from "../types";

const RATINGS: Array<{ grade: Grade; label: string }> = [
  { grade: "again", label: "Nochmal" },
  { grade: "hard", label: "Schwer" },
  { grade: "good", label: "Gut" },
  { grade: "easy", label: "Leicht" },
];

interface FlashcardCardProps {
  exercise: LearningExercise;
  onGrade: (grade: Grade, elapsedSeconds: number) => void;
}

export function FlashcardCard({ exercise, onGrade }: FlashcardCardProps) {
  const [flipped, setFlipped] = useState(false);
  const [startedAt] = useState(Date.now());

  function grade(value: Grade) {
    const elapsedSeconds = Math.max(8, Math.round((Date.now() - startedAt) / 1000));
    onGrade(value, elapsedSeconds);
  }

  return (
    <section className="flashcard">
      <div className="flashcard-meta">
        <span>{exercise.topic}</span>
        <span>Karteikarte</span>
      </div>
      <h3 className="flashcard-front">{exercise.prompt}</h3>

      {flipped ? (
        <div className="flashcard-back">
          <p>{exercise.explanation}</p>
          <div className="source-row">
            {exercise.sources.map((source) =>
              source.url ? (
                <a href={source.url} key={source.id} rel="noreferrer" target="_blank">
                  {source.label}
                </a>
              ) : (
                <span key={source.id}>{source.label}</span>
              )
            )}
          </div>
          <NormTextList sources={exercise.sources} />
          <p className="flashcard-rate-hint">Wie sicher saß das?</p>
          <div className="flashcard-ratings">
            {RATINGS.map((rating) => (
              <button
                className={`rating rating-${rating.grade}`}
                key={rating.grade}
                onClick={() => grade(rating.grade)}
                type="button"
              >
                {rating.label}
              </button>
            ))}
          </div>
        </div>
      ) : (
        <button className="primary-action flashcard-flip" onClick={() => setFlipped(true)} type="button">
          Umdrehen
        </button>
      )}
    </section>
  );
}
